import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { siteConfig } from '../data/mock';

export default function RefundsPage() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 py-24">
          <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">
            Refund & Cancellation Policy
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-8 text-white/70">
            <p className="text-lg">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Cancellation Policy</h2>
              <p>
                You may cancel your subscription at any time through your account settings. Your cancellation will take effect at the end of your current billing period, and you will continue to have access to paid features until that time.
              </p>
              <div className="p-4 bg-[#C9A962]/10 border border-[#C9A962]/30">
                <p className="text-white/90 font-medium">
                  {siteConfig.cancellationNote}
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Refund Policy</h2>
              <p>
                We offer refunds under the following circumstances:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong className="text-white">Within 7 days of initial purchase:</strong> Full refund, no questions asked</li>
                <li><strong className="text-white">Technical issues:</strong> If you experience significant technical problems that prevent you from using the service, we will provide a prorated refund</li>
                <li><strong className="text-white">Duplicate charges:</strong> Any accidental duplicate charges will be fully refunded</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">How to Request a Refund</h2>
              <p>
                To request a refund:
              </p>
              <ol className="list-decimal list-inside space-y-2 ml-4">
                <li>Email us at <span className="text-[#C9A962]">{siteConfig.supportEmail}</span></li>
                <li>Include your account email and reason for the refund request</li>
                <li>We will respond within 2-3 business days</li>
              </ol>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Refund Processing</h2>
              <p>
                Approved refunds will be processed within 5-10 business days and credited to the original payment method. The exact timing may vary depending on your financial institution.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Data After Cancellation</h2>
              <p>
                After cancellation:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>You will have access to export all your data before account closure</li>
                <li>Your data will be retained for 30 days after the end of your subscription</li>
                <li>After 30 days, all data will be permanently deleted</li>
                <li>You may request immediate deletion at any time by contacting support</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Billing Information</h2>
              <div className="p-4 bg-white/5 border border-white/10">
                <p className="text-white/70">
                  {siteConfig.chargesDisclaimer}
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Contact Us</h2>
              <p>
                If you have any questions about our refund or cancellation policies, please contact us at:
              </p>
              <p className="text-[#C9A962]">{siteConfig.supportEmail}</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
